import React, {
  useState,
  useEffect
} from "react";

import { useNavigate } from "react-router-dom";

import {
  getProformas,
  deleteProforma,
  generatePdf,
  getPdfUrl
} from "../../services/proformaService";

function ProformasList() {

  const navigate = useNavigate();

  const [proformas, setProformas] = useState([]);

  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);

  const itemsPerPage = 8;

  // ===========================
  // Chargement
  // ===========================

  const fetchData = async () => {

    try {

      const res = await getProformas();

      setProformas(res);

    } catch (err) {

      console.error(err);

      alert("Impossible de charger les proformas.");

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {

    fetchData();

  }, []);

  // ===========================
  // Suppression
  // ===========================

  const handleDelete = async (id) => {

    const raison = prompt(
      "Raison de suppression ?"
    );

    if (!raison) return;

    if (!window.confirm(
      "Confirmer la suppression ?"
    )) return;

    try {

      await deleteProforma(id);

      setProformas(prev =>
        prev.filter(p => p.id !== id)
      );

    } catch (err) {

      console.error(err);

      alert("Erreur lors de la suppression.");

    }

  };

  // ===========================
  // Génération PDF
  // ===========================

  const handleGenerate = async (id) => {

    try {

      await generatePdf(id);

      await fetchData();

      alert("PDF généré.");

    } catch (err) {

      console.error(err);

      alert("Erreur génération PDF.");

    }

  };

  // ===========================
  // Téléchargement
  // ===========================

  const handleDownload = (pdfPath) => {

    if (!pdfPath) {

      return alert(
        "Veuillez générer le PDF."
      );

    }

    window.open(
      getPdfUrl(pdfPath),
      "_blank"
    );

  };

  // ===========================
  // Recherche
  // ===========================

  const filtered = proformas.filter(p => {

    const text = `
      ${p.numero}
      ${p.contact || ""}
      ${p.telephone || ""}
      ${p.email || ""}
    `
    
      .toLowerCase();

    return text.includes(
      search.toLowerCase()
    );

  });

  // ===========================
  // Pagination
  // ===========================

  const totalPages = Math.ceil(
    filtered.length / itemsPerPage
  );

  const current = filtered.slice(

    (page - 1) * itemsPerPage,

    page * itemsPerPage

  );

  // ===========================
  // RENDER
  // ===========================

  return (

    <div className="p-3 md:p-6 bg-gray-100 min-h-[100dvh] space-y-5">

      <div className="flex flex-col md:flex-row justify-between gap-3">

        <h2 className="text-3xl font-bold">

          📄 Proformas

        </h2>

        <div className="flex gap-2 flex-wrap">

          <button

            onClick={() =>
              navigate("/proformas/new")
            }

            className="bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-xl"

          >

            ➕ Nouvelle

          </button>

          <button

            onClick={() =>
              navigate("/dashboard")
            }

            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-3 rounded-xl"

          >

            ⬅ Dashboard

          </button>

        </div>

      </div>

      <input

        type="text"

        value={search}

        placeholder="Rechercher..."

        onChange={(e)=>{

          setSearch(e.target.value);

          setPage(1);

        }}

        className="w-full border rounded-xl px-4 py-3"

      />

            {/* ===========================
          MOBILE
      ============================ */}

      <div className="grid gap-3 md:hidden">

        {loading ? (

          <div className="bg-white rounded-xl p-5 shadow">

            Chargement...

          </div>

        ) : (

          current.map((p) => (

            <div
              key={p.id}
              className="bg-white rounded-2xl shadow p-4"
            >

              <div className="space-y-1">

                <h3 className="font-bold text-blue-700">

                  {p.numero}

                </h3>

                <p>

                  <strong>Demandeur :</strong>{" "}
                  {p.contact || "-"}

                </p>

                <p>

                  <strong>Total :</strong>{" "}
                  {Number(p.montant_total || 0).toLocaleString("fr-FR", {
                    minimumFractionDigits: 2
                  })}{" "}
                  {p.devise}

                </p>

                <p>

                  <strong>Langue :</strong>{" "}
                  {p.langue}

                </p>

              </div>

              <div className="grid grid-cols-2 gap-2 mt-4">

                <button
                  onClick={() => handleGenerate(p.id)}
                  className="bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-xl"
                >
                  PDF
                </button>

                <button
                  onClick={() => handleDownload(p.pdf_path)}
                  className="bg-green-600 hover:bg-green-700 text-white py-2 rounded-xl"
                >
                  Télécharger
                </button>

                <button
                  onClick={() =>
                    navigate(`/proformas/${p.id}/edit`)
                  }
                  className="bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-xl"
                >
                  Modifier
                </button>

                <button
                  onClick={() => handleDelete(p.id)}
                  className="bg-red-600 hover:bg-red-700 text-white py-2 rounded-xl"
                >
                  Supprimer
                </button>

              </div>

            </div>

          ))

        )}

      </div>

      {/* ===========================
          DESKTOP
      ============================ */}

      <div className="hidden md:block bg-white rounded-2xl shadow overflow-x-auto">

        <table className="min-w-full">

          <thead className="bg-gray-100">

            <tr>

              <th className="px-4 py-3 text-left">
                Numéro
              </th>

              <th className="px-4 py-3 text-left">
                Demandeur
              </th>

              <th className="px-4 py-3 text-right">
                Total
              </th>

              <th className="px-4 py-3 text-center">
                Langue
              </th>

              <th className="px-4 py-3 text-center">
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan="6"
                  className="text-center py-8"
                >

                  Chargement...

                </td>

              </tr>

            ) : (

              current.map((p) => (

                <tr
                  key={p.id}
                  className="border-t hover:bg-gray-50"
                >

                  <td className="px-4 py-3 font-semibold text-blue-700">

                    {p.numero}

                  </td>

                  <td className="px-4 py-3">

                    {p.contact || "-"}

                  </td>

                  <td className="px-4 py-3 text-right">

                    {Number(p.montant_total || 0).toLocaleString("fr-FR", {
                      minimumFractionDigits: 2
                    })}{" "}
                    {p.devise}

                  </td>

                  <td className="px-4 py-3 text-center">

                    {p.langue}

                  </td>

                  <td className="px-4 py-3">

                    <div className="flex gap-2 justify-center">

                      <button
                        onClick={() => handleGenerate(p.id)}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg"
                      >
                        PDF
                      </button>

                      <button
                        onClick={() => handleDownload(p.pdf_path)}
                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg"
                      >
                        Télécharger
                      </button>

                      <button
                        onClick={() =>
                          navigate(`/proformas/${p.id}/edit`)
                        }
                        className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-2 rounded-lg"
                      >
                        Modifier
                      </button>

                      <button
                        onClick={() => handleDelete(p.id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg"
                      >
                        Supprimer
                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

            {/* ===========================
          PAGINATION
      ============================ */}

      <div className="flex justify-between items-center text-sm">

        <span>

          Page {page} / {totalPages || 1}

        </span>

        <div className="flex gap-2">

          <button

            disabled={page === 1}

            onClick={() =>
              setPage(page - 1)
            }

            className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-40"

          >

            ←

          </button>

          <button

            disabled={
              page >= totalPages ||
              totalPages === 0
            }

            onClick={() =>
              setPage(page + 1)
            }

            className="px-4 py-2 bg-gray-200 rounded-xl disabled:opacity-40"

          >

            →

          </button>

        </div>

      </div>

    </div>

  );

}

export default ProformasList;